__turbopack_context__.v({
  "body": "LoadingScreen-module-scss-module__nKadMa__body",
  "content": "LoadingScreen-module-scss-module__nKadMa__content",
  "description": "LoadingScreen-module-scss-module__nKadMa__description",
  "line-break": "LoadingScreen-module-scss-module__nKadMa__line-break",
  "logo": "LoadingScreen-module-scss-module__nKadMa__logo",
  "spinner": "LoadingScreen-module-scss-module__nKadMa__spinner",
  "text-align_center": "LoadingScreen-module-scss-module__nKadMa__text-align_center",
});
